module.exports = __webpack_public_path__ + "img/achievement1.61f30695.jpeg";